export default "__VITE_ASSET__59c3b87b__"